import { createContext, useContext, useMemo, type ReactNode } from 'react'
import {
  BookRepository,
  GarmentRepository,
  ProjectRepository,
  PatternRepository,
  SizeChartRepository,
  SettingsRepository,
} from '../db/repositories'

export interface Repos {
  books: BookRepository
  garments: GarmentRepository
  projects: ProjectRepository
  patterns: PatternRepository
  sizeCharts: SizeChartRepository
  settings: SettingsRepository
}

const ReposContext = createContext<Repos | null>(null)

export function ReposProvider({ dek, children }: { dek: Uint8Array; children: ReactNode }) {
  const repos = useMemo<Repos>(
    () => ({
      books: new BookRepository(dek),
      garments: new GarmentRepository(dek),
      projects: new ProjectRepository(dek),
      patterns: new PatternRepository(dek),
      sizeCharts: new SizeChartRepository(dek),
      settings: new SettingsRepository(dek),
    }),
    [dek],
  )
  return <ReposContext.Provider value={repos}>{children}</ReposContext.Provider>
}

export function useRepos(): Repos {
  const ctx = useContext(ReposContext)
  if (!ctx) throw new Error('useRepos deve essere usato dentro ReposProvider')
  return ctx
}
